<template>
    <div class="pie-component">
        <Pie v-if="loaded" id="pie" :data="pieData" :options="pieOpts" :key="key"/>
    </div>
    
</template>

<script lang="ts">
import PieComponent from './PieComponent';
export default PieComponent;
</script>

<style lang="scss" src="./PieComponent.scss"></style>